import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetRoutesQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Array<Types.RouteDocumentSortInput> | Types.RouteDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRoutesQuery = { __typename?: 'Query', routes?: { __typename?: 'RoutesConnection', totalCount: number, nodes?: Array<{ __typename?: 'RouteDocument', route: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetTenantRouteConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantRouteConfigQuery = { __typename?: 'Query', tenantRouteConfig?: { __typename?: 'TenantRouteConfigDocument', tenantId: string, route: string } | null };

export type TenantRouteConfigDetailsFragment = { __typename?: 'TenantRouteConfigDocument', tenantId: string, route: string };

export const TenantRouteConfigDetailsFragmentDoc = new TypedDocumentString(`
    fragment TenantRouteConfigDetails on TenantRouteConfigDocument {
  tenantId
  route
}
    `, {"fragmentName":"TenantRouteConfigDetails"});
export const GetRoutesDocument = new TypedDocumentString(`
    query GetRoutes($search: String, $order: [RouteDocumentSortInput!], $first: Int, $after: String) {
  routes(search: $search, order: $order, first: $first, after: $after) {
    nodes {
      route
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetTenantRouteConfigDocument = new TypedDocumentString(`
    query GetTenantRouteConfig {
  tenantRouteConfig {
    ...TenantRouteConfigDetails
  }
}
    fragment TenantRouteConfigDetails on TenantRouteConfigDocument {
  tenantId
  route
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetRoutes: build.query<GetRoutesQuery, GetRoutesQueryVariables | void>({
      query: (variables) => ({ document: GetRoutesDocument, variables })
    }),
    GetTenantRouteConfig: build.query<GetTenantRouteConfigQuery, GetTenantRouteConfigQueryVariables | void>({
      query: (variables) => ({ document: GetTenantRouteConfigDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetRoutesQuery, useLazyGetRoutesQuery, useGetTenantRouteConfigQuery, useLazyGetTenantRouteConfigQuery } = injectedRtkApi;
